import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { QuillModule } from 'ngx-quill';

import { WorkflowAssistantComponent } from './workflow-assistant.component';
import { WorkflowAssistantSuggestionsDialogComponent } from './workflow-assistant-suggestions-dialog.component';
import { WorkflowAssistantFeedbackDialogComponent } from './workflow-assistant-feedback-dialog.component';

@NgModule({
  declarations: [WorkflowAssistantComponent, WorkflowAssistantSuggestionsDialogComponent, WorkflowAssistantFeedbackDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatDialogModule,
    MatSelectModule,
    QuillModule.forRoot(),
  ],
  exports: [WorkflowAssistantComponent],
})
export class WorkflowAssistantModule { }
